<template>
  <b-row class="diagram-area" id="test">
    <b-col xl="3" v-for="(field,index) in fields" :key="index">
      <div class="box" v-if="!field.length" :id="'div' + index">
        <p class="answer">{{ field.answer }}</p>
        <hr>
        <p class="reply mr-3" v-if="field.reply.length"><span class="mr-3" v-for="rply in field.reply">{{ rules[rply] }}</span></p>
        <p class="reply" v-else>{{ rules[field.reply] }}</p>

        <b-badge :variant="types[field.type]">{{ field.type }}</b-badge>
        <span  @click="removeBox" class="close"><i class="far fa-times-circle"></i></span>
      </div>
      <div class="group-box" v-else :id="'div' + index">
        <div class="box" v-for="item in field">
          <p class="answer">{{ item.answer }}</p>
          <hr>
          <p class="reply" v-if="item.reply.length"><span class="mr-3" v-for="rply in item.reply">{{ rules[rply] }}</span></p>
          <p class="reply" v-else>{{ rules[item.reply] }}</p>

          <b-badge :variant="types[item.type]">{{ item.type }}</b-badge>
          <span  @click="removeBox" class="close"><i class="far fa-times-circle"></i></span>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

import TextInput from "@/assets/components/inputs/TextInput";
import Swal from "sweetalert2";
import $ from 'jquery';

export default {
  name: "Diagram",
  components: {TextInput},
  props: ['field', 'group_status', 'clear'],
  data() {
    return {
      fields: [],
      rules: {
        1: 'İlkokul',
        2: 'Ortaokul',
        3: 'Lise',
        4: 'Üniversite',
        5: 'Menderes İlköğretim Okulu',
        6: 'Nene Hatun İlk Öğretim Okulu',
        7: 'Menderes Ortaöğretim Okulu',
        8: 'Nene Hatun Orta Öğretim Okulu',
        9: 'Menderes Lisesi',
        10: 'Nene Hatun Lisesi',
        11: 'Futbol',
        12: 'Basketbol',
        13: 'Tenis',
        14: 'Koşu',
        15: 'Kitap okurum',
        16: 'Gezerim',
        17: 'Oyun oynarım',
        18: 'Ailemle vakit geçiririm',
        19: 'Turkcell',
        20: 'Vodafone',
        21: 'Turktelekom',
        22: 'İstanbul',
        23: 'Bahçelievler',
        24: 'Beşiktaş',
        25: 'Sarıyer',
        26: 'Ankara',
        27: 'İzmir',
        28: 'Samsun',
        29: 'Gaziantep',
        30: 'Balıkesir'
      },
      group: false,
      index: 0,
      group_id: 0,
      box_count: 0,
      types : {
        'Ve' : 'primary',
        'Veya' : 'warning',
        'Grup Ve' : 'danger',
        'Grup Veya' : 'secondary'
      }
    }
  },
  methods: {
    connect(div1, div2, color, thickness) {
      setTimeout(() => {
        var off1 = this.getOffset(div1);
        var off2 = this.getOffset(div2);
        // bottom right
        var x1 = off1.left + off1.width;
        var y1 = off1.top + off1.height - (off1.height / 2);
        // top right
        var x2 = off2.left;
        var y2 = off2.top + off2.height - (off2.height / 2);
        // distance
        var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
        // center
        var cx = ((x1 + x2) / 2) - (length / 2);
        var cy = ((y1 + y2) / 2) - (thickness / 2);
        // angle
        var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
        // make hr
        var htmlLine = "<div id='line-" + div2 + "' style='padding:0px; margin:0px; height:" + thickness + "px; background-color:" + color + "; line-height:1px; position:absolute; left:" + cx + "px; top:" + cy + "px; width:" + length + "px; -moz-transform:rotate(" + angle + "deg); -webkit-transform:rotate(" + angle + "deg); -o-transform:rotate(" + angle + "deg); -ms-transform:rotate(" + angle + "deg); transform:rotate(" + angle + "deg);' />";
        //
        $('body').append(htmlLine);
      }, 500)
    },
    getOffset(el) {
      var div = document.getElementById(el);
      var rect = div.getBoundingClientRect();
      return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        width: rect.width || el.offsetWidth,
        height: rect.height || el.offsetHeight
      };
    },
    removeBox(){
      Swal.fire({
        title: "",
        text: "Kural başarıyla kaldırıldı.",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText: "Tamam"
      });
    }
  },
  mounted() {

  },
  beforeDestroy () {
    $('[id^=line-div]').remove();
  },
  watch: {
    field: {
      immediate: true,
      handler(val, oldVal) {
        if (val != null) {
          if (val.reply && val.type && val.answer) {

            if (val.new_group && !val.group) {
              //ve -veya gönderildiyse
              this.fields.splice(this.index, 0, {
                answer: val.answer,
                reply: val.reply,
                type: val.type
              })
              this.index++;
              this.box_count++;
            } else if (val.new_group && val.group) {
              //grup ve - grup veya gönderildiyse
              this.group_id = this.index;
              this.fields.splice(this.index, 0, [{
                answer: val.answer,
                reply: val.reply,
                type: val.type
              }])
              this.index++;
              this.box_count++;

            } else {
              //grup içine ve - veya gönderildiyse

              if (typeof this.fields[this.group_id] != "undefined"){
                this.fields[this.group_id].push({
                  answer: val.answer,
                  reply: val.reply,
                  type: val.type
                })
              }else{
                Swal.fire({
                  title: "",
                  text: "Hatalı profilleme işlemi yaptınız. Lütfen kontrol ediniz.",
                  icon: "error",
                  confirmButtonClass: "btn btn-secondary",
                  confirmButtonText: "Tamam"
                });
                return false;
              }
            }

            (val.group === true) ? this.group = true : '';
          } else {
            Swal.fire({
              title: "",
              text: "Eksik bilgi girdiniz. Lütfen kontrol ediniz.",
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              confirmButtonText: "Tamam"
            });
          }
        }

        if (this.fields.length) {
          if (this.fields.length > 1) {
            let self = this;
            self.field_count = 0;

            let div1 = Number(this.index) - 2;
            let div2 = Number(this.index) - 1;

            if (!$('#line-div' + div2).length) {
              self.connect("div" + div1.toString(), "div" + div2.toString(), "#d0d0d0", 2);
            }
          }
        }
      }
    },
    clear: {
      immediate: true,
      handler(val, oldVal) {
        this.$forceUpdate();

        if (val){
          this.fields = [];
          this.index = 0;
          this.group = false;
          this.group_id = 0;
          this.box_count = 0;
          $('[id^=line-div]').remove();
        }
      }
    }
  }
};
</script>

<style scoped>
.diagram-area {
  background-color: #edf0f7;
  border-radius: 8px;
  min-height: 600px;
  padding: 10px 0;
}

.diagram-area .group-box {
  padding: 5px 0;
  background-color: #eef0f8;
  color: #fff;
  overflow: visible;
  border-radius: 4px;
  border: 2px solid #d0d0d0;
}

.diagram-area .box {
  height: 150px;
  overflow: hidden;
  padding: 5px;
  border: 2px solid #e4e4e4;
  background-color: #f9f9f9;
  color: #474f5f;
  margin: 10px;
  border-radius: 4px;
  z-index: 99;
}

.box .answer {
  font-size: 12px;
}

.box .reply {
  font-size: 10px;
  margin: 0;
}
.box{
  position: relative;
}
.box .close{
  position:absolute;
  bottom:5px;
  right:5px;
}
.close i {
  color: #ff001b;
}
.box .badge{
  margin-top: 10px;
}


</style>